import { BaseTableRows, HeadCell } from 'shell/components/shared/table/types';

export type TableMatricolaVM = {
  matricola: string;
  gender?: string;
  action: React.ReactElement;
} & BaseTableRows;

export const headCells: HeadCell<TableMatricolaVM, keyof TableMatricolaVM>[] = [
  {
    id: 'matricola',
    label: 'Matricola',
    colSpan: 5,
  },
  {
    id: 'action',
    label: 'Azione',
    colSpan: 1,
  },
];
